import React, { useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { useForm } from '../../hooks/useForm';
import { useSetClaimAssignment } from '../../services/claims';
import AdminSelect from '../common/AdminSelect';

const AssignToModal = ({ show, toggle, claim, onSuccess }) => {
  const { form, onChange, setValues } = useForm({ assignTo: null });

  const updateClaimWithUser = useSetClaimAssignment(
    () => {
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
      toggle();
    },
    { onError: (err) => toast.error(err.message) }
  );

  useEffect(() => {
    if (claim && claim.adminId) {
      setValues(
        {
          assignTo: {
            label: `${claim.adminLastName}, ${claim.adminFirstName}`,
          },
          value: claim.adminId,
        },
        true
      );
    } else {
      setValues({ assignTo: null }, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claim]);

  const onSubmit = (e) => {
    e.preventDefault();

    updateClaimWithUser.mutate({
      claimId: claim.claimId,
      body: {
        claimAssignedToUserId: form.assignTo ? form.assignTo.value : null,
      },
    });
  };

  return (
    <Modal show={show} onHide={() => toggle()}>
      <Modal.Body>
        <form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label>Assign To</Form.Label>
            <AdminSelect
              value={form.assignTo}
              onChange={(val) => {
                console.log(val);
                onChange({ target: { name: 'assignTo', value: val } });
              }}
            />
          </Form.Group>
          <hr />
          <Button
            variant="success"
            type="submit"
            disabled={updateClaimWithUser.isLoading}
          >
            <FontAwesomeIcon
              icon={updateClaimWithUser.isLoading ? faSpinner : faCheck}
              spin={updateClaimWithUser.isLoading}
            />{' '}
            Assign
          </Button>{' '}
          <Button variant="link" onClick={() => toggle()}>
            Cancel
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AssignToModal;
